jQuery(document).ready(function($) {

	$('.faqs--more').on('click',function(e){
		e.preventDefault();
		$( $(this).attr('href') ).removeClass('is-collapsed');
		$(this).remove();
	});

});
